import {useDispatch, useSelector} from "react-redux";
import {updateSmaSettings} from "../../../../store/slices/sma.slice";
import React, {useState} from "react";
import {Col, Divider, Row} from "antd";
import SmaMenu from "./SmaMenu";
import SmaMetadata from "./SmaMetadata";
import Button from "@mui/material/Button";
import {SortByAlphaRounded, SortRounded} from "@mui/icons-material";
import EtfController from "./EtfController";
import SmaTickersTable from "../../SmaTickersTable";
import SmaDetails from "../../components/SmaDetails";

const SmaConfigurator = ({   etfData, tickerData, fullData, etfColors,
                          sectorColors, config, blacklists, screens,
                          summaryDetails, etfContributions, callbacks
})=>{
    const dispatch = useDispatch();
    const sortEtfs = useSelector(state=>state.sma.smaSettings.sortEtfs);


    const {
        updateConfig,
        toggleReplicateEtf,
        removeEtf,
        updateEtfWeight,
        saveSma
    } = callbacks

    const toggleSortEtfs = ()=>{
        dispatch(updateSmaSettings({sortEtfs: !sortEtfs}))
    }

    const [showEtfBanner, setShowEtfBanner] = useState(true);


    const toggleEtfBanner = ()=>setShowEtfBanner(!showEtfBanner);
    return (
        <>
            <Row wrap={false}>
                <Col flex={'0 0 300px'}>
                    <SmaMenu blacklists={blacklists}
                             screens={screens}
                             config={config}
                             updateConfig={updateConfig}
                             etfContributions={etfContributions}
                    />
                </Col>
                <Col flex={'auto'} style={{padding: '0px 60px'}}>
                    <div className={'bordered round-2 py-3 px-5'}>
                        <SmaMetadata updateConfig={updateConfig} currentSmaConfig={config} handleSave={saveSma}
                                     showEtfBanner={showEtfBanner} toggleEtfBanner={toggleEtfBanner}
                                     extra={
                                            <Button variant={'outlined'} startIcon={sortEtfs ? <SortRounded /> : <SortByAlphaRounded/>} onClick={toggleSortEtfs}>
                                                {sortEtfs ? 'Sort by Weight' : 'Sort by Symbol'}
                                            </Button>
                                     }

                        />
                        <EtfController etfs={etfData} updateEtfWeight={updateEtfWeight} removeEtf={removeEtf}
                                      toggleReplicateEtf={toggleReplicateEtf}
                                      wrap={showEtfBanner} sort={sortEtfs}
                                      etfContributions={etfContributions}
                                      minWeightTolerance={config.minWeightTolerance}
                        />
                    </div>
                    <Divider/>
                    <SmaDetails summaryDetails={summaryDetails} cutHoldings={tickerData} fullHoldings={fullData}/>
                    <Divider/>
                    {tickerData && <SmaTickersTable data={tickerData} etfColors={etfColors} sectorColors={sectorColors}/>
}
                </Col>
            </Row>
        </>
    )
}

export default SmaConfigurator;